import { handleMessageEmit } from '@/methods/message/handleMessageEmit'

import { WS_EVENT_ROOM, WS_EVENT_ROOM_STATES } from '@/constants/socketEvent'

export function sendChathistory({ socket }: any) {
  const infoContent = {
    sid: WS_EVENT_ROOM.sid,
    ssid: WS_EVENT_ROOM.state,
    body: [{ key: WS_EVENT_ROOM_STATES.chathistory, value: '1,100' }],
  }

  handleMessageEmit({ socket, content: infoContent })
}
